import { GC_GET_LOG_TYPE_LIST, GC_GET_LOG_LIST, GC_GET_LOG_BY_TYPE_SLUG, GC_GET_LOG_HISTORY_BY_TYPE_SLUGS, GC_GET_LOG_BY_DATA_KEY_AND_TYPE_SLUG, GC_GET_LOG_BY_DATA_KEYS_AND_TYPE_SLUG, GC_GET_LOG_BY_DATA_KEY, GC_ADD_LOG_ONE, GC_ADD_LOG_ONE_DETAILS, GC_UPDATE_LOG_ONE } from '@/graphql/log'
import apollo from '@/apolloClient'

const maxLogInterval = (1000 * 60 * 20) // 20 min
window.lastLogTime = Date.now()

export default {
    namespaced: true,
    state: {
        list: [],
        listByTypeSlug: {},
        type_list: [],
        media_history: [],
    },
    mutations: {
        SET_LOG_TYPE_LIST(state, types) {
            state.type_list = types;
        },
        SET_LOG_LIST(state, logs) {
            state.list = (logs || [])
        },
        SET_MEDIA_HISTORY_LIST(state, logs) {
            state.media_history = (logs || [])
        },
        ADD_MEDIA_HISTORY_LOG(state, log) {
            if (!log)
                return

            state.media_history.push(log)
        },
    },
    actions: {
        async getTypeList({ commit }) {
            const response = await apollo.query({ query: GC_GET_LOG_TYPE_LIST })

            commit('SET_LOG_TYPE_LIST', response.data.log_type)
        },
        async getList({ commit }) {
            const response = await apollo.query({ query: GC_GET_LOG_LIST })

            commit('SET_LOG_LIST', response.data.log)
        },
        async getByTypeSlug({ rootState }, { type_slug }) {
            // Get user id
            const user_id = rootState.Auth.user.id

            if (!user_id)
                return

            let response = await apollo.query({
                query: GC_GET_LOG_BY_TYPE_SLUG,
                variables: { type_slug, user_id }
            })

            return (response && response.data && response.data.logs)
        },
        async getByKey({ rootState }, data_key) {
            // Get user id
            const user_id = rootState.Auth.user.id

            if (!user_id)
                return

            let response = await apollo.query({
                query: GC_GET_LOG_BY_DATA_KEY,
                variables: { data_key, user_id }
            })

            return (response && response.data && response.data.logs)
        },
        async getByKeyAndType({ rootState }, { data_key, type_slug }) {
            // Get user id
            const user_id = rootState.Auth.user.id

            if (!user_id)
                return

            let response = await apollo.query({
                query: GC_GET_LOG_BY_DATA_KEY_AND_TYPE_SLUG,
                variables: { data_key, type_slug, user_id }
            })

            return (response && response.data && response.data.logs)
        },
        async getByKeysAndType({ rootState }, { data_keys, type_slug }) {
            // Get user id
            const user_id = rootState.Auth.user.id

            if (!user_id)
                return

            let response = await apollo.query({
                query: GC_GET_LOG_BY_DATA_KEYS_AND_TYPE_SLUG,
                variables: { data_keys, type_slug, user_id }
            })

            return (response && response.data && response.data.logs)
        },
        async loadMediaHistory({ commit, rootState }) {
            // Get user id
            const user_id = rootState.Auth.user.id

            if (!user_id)
                return

            let response = await apollo.query({
                query: GC_GET_LOG_HISTORY_BY_TYPE_SLUGS,
                variables: { type_slugs: [ 'view_pdf', 'media_start' ], user_id }
            })

            commit('SET_MEDIA_HISTORY_LIST', response.data.logs)

            return (response && response.data && response.data.logs)
        },
        async addMediaHistory({ state, commit, dispatch, rootState }, { data_key, data, type_slug }) {
            // Check last log time for user inactivity
            const now = Date.now()

            if ((now - window.lastLogTime) > maxLogInterval) {
                await dispatch('Auth/logout', null, { root: true })
                return false
            }

            if (!state.type_list || state.type_list.length <= 0) {
                await dispatch('getTypeList')

                if (state.type_list.length <= 0)
                    return// todo
            }

            // Find log type id
            const log_type = state.type_list.find((type) => {
                return (type.slug == type_slug)
            })

            if (!log_type)
                return

            // Get user id
            const user_id = rootState.Auth.user.id

            if (!user_id)
                return

            const response = await apollo.mutate({
                mutation: GC_ADD_LOG_ONE_DETAILS,
                variables: {
                    data_key,
                    data,
                    log_type_id: log_type.id,
                    user_id
                }
            })

            commit('ADD_MEDIA_HISTORY_LOG', response.data.insert_logs_one)

            window.lastLogTime = now

            return (response && response.data && response.data.insert_logs_one)
        },
        async save({ state, dispatch, rootState }, { id, data_key, data, type_slug }) {
            // Check last log time for user inactivity
            const now = Date.now()

            if ((now - window.lastLogTime) > maxLogInterval) {
                await dispatch('Auth/logout', null, { root: true })
                return false
            }

            if (!state.type_list || state.type_list.length <= 0) {
                await dispatch('getTypeList')

                if (state.type_list.length <= 0)
                    return// todo
            }

            // Find log type id
            const log_type = state.type_list.find((type) => {
                return (type.slug == type_slug)
            })

            if (!log_type)
                return

            // Get user id
            const user_id = rootState.Auth.user.id

            if (!user_id)
                return

            if (id) {
                // Update the log
                const response = await apollo.mutate({
                    mutation: GC_UPDATE_LOG_ONE,
                    variables: {
                        id,
                        data_key,
                        data,
                        log_type_id: log_type.id,
                        user_id
                    }
                })

                // Update store data todo: ?
                // await dispatch('getByID', (gql_data.log.id || result.id))

                window.lastLogTime = now

                return response
            } else {
                // Add the log
                const response = await apollo.mutate({
                    mutation: GC_ADD_LOG_ONE,
                    variables: {
                        data_key,
                        data,
                        log_type_id: log_type.id,
                        user_id
                    }
                })

                // Update store data todo: ?
                // await dispatch('getByID', (gql_data.log.id || result.id))

                window.lastLogTime = now

                return response
            }
        }
    }
}